module.exports = __webpack_public_path__ + "img/4-sepia.35ab3f2.png";


//////////////////
// WEBPACK FOOTER
// ./uncommon-client/assets/4-sepia.png
// module id = bOkG
// module chunks = 1